/**
 * Presentation ViewModels — UI-specific formatting for SEO
 */

import type { ListingSeo, ExploreLink } from '../../domain/models/Seo';
import { SEO_BASE_URL_PLACEHOLDER, SEO_BASE_URL } from '../../constants';

function resolveSeoUrl(url: string): string {
  return url.replace(SEO_BASE_URL_PLACEHOLDER, SEO_BASE_URL);
}

function resolveSeoText(text: string): string {
  return text.replace(new RegExp(SEO_BASE_URL_PLACEHOLDER, 'g'), SEO_BASE_URL);
}

export interface ExploreLinkPresentationVm {
  label: string;
  url: string;
  hoverTitle?: string | null;
}

export interface ListingSeoPresentationVm {
  title?: string;
  description?: string;
  canonical?: string;
  shareUrl?: string;
  seoText?: string;
  keywords?: string;
  robotsMeta?: string;
  schema?: unknown;
  prev?: string;
  next?: string;
  header?: string;
  seoLinks?: ExploreLinkPresentationVm[];
}

export function toExploreLinksPresentation(links: ExploreLink[] | undefined): ExploreLinkPresentationVm[] | undefined {
  if (!links?.length) return undefined;
  return links.map((l) => ({
    label: l.label,
    url: resolveSeoUrl(l.url),
    hoverTitle: l.hoverTitle ?? null,
  }));
}

export function toSeoPresentationVm(seo: ListingSeo | undefined): ListingSeoPresentationVm | undefined {
  if (!seo) return undefined;
  return {
    ...(seo.title && { title: seo.title }),
    ...(seo.description && { description: seo.description }),
    ...(seo.canonical && { canonical: seo.canonical }),
    ...(seo.shareUrl && { shareUrl: seo.shareUrl }),
    ...(seo.seoText && { seoText: resolveSeoText(seo.seoText) }),
    ...(seo.keywords && { keywords: seo.keywords }),
    ...(seo.robotsMeta && { robotsMeta: seo.robotsMeta }),
    ...(seo.schema != null && { schema: seo.schema }),
    ...(seo.prev && { prev: seo.prev }),
    ...(seo.next && { next: seo.next }),
    ...(seo.header && { header: seo.header }),
    ...(seo.seoLinks?.length && { seoLinks: toExploreLinksPresentation(seo.seoLinks) }),
  };
}
